<div class="date-picker-contaier" *ngIf="!to.disabled; else temp">
    <input [tabIndex]="to?.tabindex" matInput [ngxMatDatetimePicker]="picker" [required]="to.required" class="mt-3"
    [formControl]="$any(formControl)" [min]="field?.templateOptions?.minValue" [max]="field?.templateOptions?.maxValue">
    <mat-datepicker-toggle class="mt-4" matSuffix [for]="$any(picker)"></mat-datepicker-toggle>
    <ngx-mat-datetime-picker class="mt-4" #picker [enableMeridian]="true" [hideTime]="field?.templateOptions?.hideTime" [showSeconds]="field?.templateOptions?.showSeconds">
    </ngx-mat-datetime-picker>
</div>
<ng-template #temp>
    <div class="flex flex-col">
        <input type="text" [value]="returnDate()" disabled>
    </div>
</ng-template>